import React from 'react';

function DefaultPage() {
  return <div>default page.</div>;
}

export default DefaultPage;
